window.Vue = require('vue');
 
Vue.component('buscador-home', require('../../componentes/sitio/BuscadorHome.vue').default);

Vue.config.productionTip = false;
Vue.config.devtools = false;

const buscador = new Vue({
    el: '#vue-buscador',
});